import { css, html, LitElement } from 'lit'
import { translate } from '../Shared/Translations'
import { property } from 'lit/decorators.js'
import { join } from 'lit/directives/join.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js'
import { Dealer, MapSettings } from './Types'

export class DealerPopup extends LitElement {
	static styles = css`
        :host {
            display: block;
            font-family: var(--font-family);
            text-align: center;
            padding: var(--space-100);
        }
        h2 {
            font-weight: var(--font-weight-light);
            font-size: var(--font-size-header-3);
            line-height: var(--font-line-height-header-3);
            margin-block: 0 var(--space-200);
            max-width: 30ch;
            text-wrap: balance;
        }
        address {
            font-style: normal;
            font-size: var(--font-size-body-lg);
            font-weight: var(--font-weight-light);
            margin-bottom: var(--space-200);
            line-height: 125%;
            max-width: 30ch;
            text-align: center;
            margin-inline: auto;
            span {
                display: inline-block;
                /* border-right: 1px solid deeppink; */
            }
        }
        div {
            display: flex;
            justify-content: space-evenly;
            gap: var(--space-200);
        }
        a {
            display: block;
            margin-bottom: 0.25em;
        }
    `

	@property({ type: Object })
	selectedDealer: Dealer | null = null


    @property({ attribute: false })
    settings?: MapSettings
    

	render() {
        if(!this.selectedDealer) return html``
        let { name, nameNative, address, addressNative, phone, homepage, languageCode } = this.selectedDealer?.properties || {}
        let websiteLabel = translate('visit-website', {}, this.settings!.language || 'en');
        if(languageCode.toLowerCase() != "en" && languageCode.toLowerCase() == this.settings!.language.toLowerCase()) {
            if(nameNative) name = nameNative
            if(addressNative) address = addressNative
        }
		return html`
            <h2>${name}</h2>            
            ${renderAddress(address)}
            <div>
                ${phone ? html`
                    <lindberg-button small solid blue href="tel:${phone}">${phone}</lindberg-button>` : ''}
                ${homepage ? html`
                    <lindberg-button small solid blue href="${(!homepage.startsWith('http') ? 'https://' : '') + homepage.trim()}" target="_blank" rel="noopener noreferrer nofollow">
                        ${websiteLabel}
                    </lindberg-button>` : ''}
            </div>
        `
	}
}

// Break opportunity after common CJK address-unit suffixes
const CJK_BREAK = /(?<=丁目|番地|[省市区區县縣镇鎮乡鄉路街巷弄号號楼樓层層室座都府県町村])/;

function renderAddress(address: string | undefined) {
    const lines = address?.split(/\s*[\r\n]+\s*/).filter(Boolean) || [];

    return html`<address>
    ${lines.map((line, li) => {
        // [text, whitespace, text, whitespace, ...], keeping the comma on the text
        const parts = line.split(/(?<=[,，、])(\s*)/);
        const pieces: { text: string; space: boolean }[] = [];

        for (let i = 0; i < parts.length; i += 2) {
            const text = parts[i].trim();
            if (!text) continue;
            const space = /\s/.test(parts[i - 1] ?? '') || !!pieces.at(-1)?.text.endsWith(',');

            text.split(CJK_BREAK).forEach((p, j) => {
                if (j > 0 && p.length === 1) pieces[pieces.length - 1].text += p; // don't orphan e.g. 铺
                else pieces.push({ text: p, space: j === 0 && space });
            });
        }

        return html`${pieces.map((p, i) =>
            html`${i === 0 ? '' : p.space ? ' ' : html`<wbr>`}<span>${p.text}</span>`
        )}${li < lines.length - 1 ? html`<br>` : ''}`;
    })}</address>`;
}
customElements.define('lindberg-dealers-popup', DealerPopup)
